"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setInboxRules_1 = require("./setInboxRules");
var store_1 = require("../store/store");
var owa_analytics_1 = require("owa-analytics");
var moveDragAndDroppableItem_1 = require("owa-dnd/lib/utils/moveDragAndDroppableItem");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Move the inbox rule above the specified node
 * @param ruleIdToMove the rule to be moved
 * @param destinationRuleId the rule to be inserted before
 */
exports.default = legacy_1.action('moveInboxRule')(legacy_1.select({
    orderedInboxRuleIds: function () { return store_1.default.inboxRulesListState.inboxRuleIds; },
})(function moveInboxRule(ruleIdToMove, destinationRuleId, state) {
    var orderedInboxRuleIds = state.orderedInboxRuleIds;
    var fromIndex = orderedInboxRuleIds.indexOf(ruleIdToMove);
    var toIndex = orderedInboxRuleIds.indexOf(destinationRuleId);
    // Move the element from the old position to the new position in the array
    moveDragAndDroppableItem_1.default(orderedInboxRuleIds, fromIndex, toIndex);
    owa_analytics_1.logUsage('TnS_MoveInboxRule', [orderedInboxRuleIds.length, fromIndex, toIndex]);
    setInboxRules_1.default();
}));
//# sourceMappingURL=moveInboxRule.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/moveInboxRule.js
// module id = 5176
// module chunks = 2